export default __webpack_public_path__ + "static/media/si.bc8b5ad6.svg";